import { render, staticRenderFns } from "./FormulaQnaMngtDetail.vue?vue&type=template&id=29aa28b5"
import script from "./FormulaQnaMngtDetail.vue?vue&type=script&lang=js"
export * from "./FormulaQnaMngtDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports